import AsyncStorage from '@react-native-async-storage/async-storage';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useNewFeatureIndicator = (featureName: string) => {
  const [showNewIndicator, setShowNewIndicator] = useState(false);
  const newFeatureIndicatorKey = useMemo(() => {
    return `newFeature:${featureName}`;
  }, [featureName]);

  useEffect(() => {
    (async () => {
      const date = await AsyncStorage.getItem(newFeatureIndicatorKey);

      if (!date) {
        setShowNewIndicator(true);
        // show new indicator for 7 days
        const expiryDate = moment().startOf('day').add(7, 'days').toISOString();
        AsyncStorage.setItem(newFeatureIndicatorKey, expiryDate);
      } else if (moment().startOf('day').isBefore(moment(date))) {
        setShowNewIndicator(true);
      }
    })();
  }, [newFeatureIndicatorKey]);

  const clearNewIndicator = useCallback(() => {
    // expire new indicator
    AsyncStorage.setItem(
      newFeatureIndicatorKey,
      moment().startOf('day').subtract(1, 'days').toISOString(),
    ).then(() => {
      setShowNewIndicator(false);
    });
  }, [newFeatureIndicatorKey]);

  return useMemo(
    () => ({
      clearNewIndicator,
      showNewIndicator,
    }),
    [clearNewIndicator, showNewIndicator],
  );
};
